import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import MultiSubaccountSearchDropdown from '../MultiSubaccountSearchDropdown/view';
import SubaccountSearchDropdown from '../SubaccountSearchDropdown/view';
import './style.css';

const AccountFilterSelector = ({
  selectedAccounts,
  onAccountsChange,
  accountRange,
  onRangeChange,
  mode = 'list',
  onModeChange
}) => {

  return (
    <div className="account-filter-selector-standard">
      <div className="d-flex align-items-center justify-content-between mb-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <Form.Label className="text-secondary small fw-bold text-uppercase mb-0" style={{ margin: 0 }}>
          Modo de selección de cuentas
        </Form.Label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '0.85rem', fontWeight: mode === 'list' ? 'bold' : 'normal', color: mode === 'list' ? 'var(--color-primary, #009688)' : 'var(--color-gray-60, #888)' }}>
            Lista Específica
          </span>
          <Form.Check 
            type="switch"
            id="account-mode-switch"
            checked={mode === 'range'}
            onChange={(e) => onModeChange(e.target.checked ? 'range' : 'list')}
            style={{ cursor: 'pointer', margin: 0 }}
            label=""
          />
          <span style={{ fontSize: '0.85rem', fontWeight: mode === 'range' ? 'bold' : 'normal', color: mode === 'range' ? 'var(--color-primary, #009688)' : 'var(--color-gray-60, #888)' }}>
            Rango de Códigos
          </span>
        </div>
      </div>

      {mode === 'list' ? (
        <div className="mt-3">
          <MultiSubaccountSearchDropdown
            selected={selectedAccounts}
            onSelected={onAccountsChange}
          />
        </div>
      ) : (
        <Row style={{ display: 'flex', gap: '15px' }}>
          <Col style={{ flex: 1 }}>
            <Form.Label className="small text-secondary">Código Desde</Form.Label>
            <SubaccountSearchDropdown
              onSelected={(account) => {
                const paddedCode = String(account?.code ?? '').padStart(2, '0');
                const fullCode = `${account?.base_account?.account || ''}${paddedCode}`;
                onRangeChange({ ...accountRange, from: fullCode });
              }}
            />
            <div className="small text-primary mt-1">Seleccionado: {accountRange.from || 'Ninguno'}</div>
          </Col>
          <Col style={{ flex: 1 }}>
            <Form.Label className="small text-secondary">Código Hasta</Form.Label>
            <SubaccountSearchDropdown
              onSelected={(account) => {
                const paddedCode = String(account?.code ?? '').padStart(2, '0');
                const fullCode = `${account?.base_account?.account || ''}${paddedCode}`;
                onRangeChange({ ...accountRange, to: fullCode });
              }}
            />
            <div className="small text-primary mt-1">Seleccionado: {accountRange.to || 'Ninguno'}</div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default AccountFilterSelector;
